import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class GroceriesService {

  getSGroceriesUrl() {
    return axios.get(apiUrl + 'groceries', { headers: authHeader() });
  }

  addGrocery(grocery) {
    return axios.post(apiUrl + 'groceries', grocery, { headers: authHeader() });
  }

  updateGrocery(grocery) {
    return axios.put(apiUrl + 'groceries', grocery, { headers: authHeader() });
  }

  deleteGrocery(id) {
    return axios.delete(apiUrl + 'groceries/' + id, { headers: authHeader() });
  }

}

export default new GroceriesService();